export const routes = {

    campusLife: {
        main: "/campus-life",
        kshasCampus: "kshas-campus"
    }


}